export default {
  props: ['id'],
  data() {
    return {
      qty: 1,
      dialog: false,
      width: window.innerWidth,
      size: '',
      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
      },
    };
  },
  computed: {
    user() { return this.$store.state.user; },
    product() { return this.$store.state.shop.product; },
    carouselHeight() {
      let height = 300;

      if (this.width < 960) {
        height = this.width - 36;
      }

      if (this.width >= 960 && this.width < 1340) {
        height = (this.width - 50) / 1.5;
      }

      if (this.width >= 1340) {
        height = 840;
      }

      return height;
    },
    userCanMakeTransaction() {
      return this.user && this.user.can_make_transaction;
    },
    userCanMakeTransactionReason() {
      return this.user && this.user.can_make_transaction_reason;
    },
  },
  methods: {
    async AddToCart(item) {
      const payload = item;
      payload.qty = this.qty;
      payload.size = this.size;
      await this.$store.dispatch('shop/AddToCart', payload);
      this.dialog = true;
    },
    ChangeQty(e) {
      this.qty = +e.target.value ? +e.target.value : 1;
    },
    ChangeSize(e) {
      this.size = e.target.value && this.product.sizes && this.product.sizes.length
        ? e.target.value
        : this.product.sizes[0];
    },
    HandleResize() {
      this.width = window.innerWidth;
    },
  },
  async mounted() {
    window.addEventListener('resize', this.HandleResize);
    await this.$store.dispatch('shop/GetProduct', { product_id: this.$props.id });
    if (this.product && this.product.sizes && this.product.sizes.length) {
      // eslint-disable-next-line prefer-destructuring
      this.size = this.product.sizes[0];
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.HandleResize);
  },
};
